import { Activityeditor } from '@linktivity/gds-neo';
import config from '../config';

const adminApi = new Activityeditor.AdminApi(config);

export default adminApi;
